// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vGo_","colMin":"styles_colMin__BtbH_"};